export const IDP_APP_IROP = 'IROP';
export const DEFAULT_TIMEOUT = 10000;

export enum IropEndpointKeys {
  IROP_GLOBAL_URL = 'IROP_GLOBAL_URL'
}
